export const LINKS = {
  ABOUT: 'ABOUT',
  JOIN: 'JOIN',
  CONTACT: 'CONTACT',
};
